import { useNavigate, useParams } from "react-router-dom";
import "./PedegreeMatrix.css";
import SideNav from "../SideNav/SideNav";
import { Col, Container, Row, Form, Button } from "react-bootstrap";

const PedegreeMatrix = () => {
    let { id } = useParams();
    let navigate = useNavigate();

    const goToBasicContext = () => {
        setTimeout(() => {
            navigate(`/pavement-context-basic/${id}`);
        }, 100);
    }

    const goToDetailedContext = () => {
        setTimeout(() => {
            navigate(`/pavement-context-custom/${id}`);
        }, 100);
    }

    const goToPedegreeMatrix = () => {
        setTimeout(() => {
            navigate(`/pedegree-matrix/${id}?backref=pavement-design`);
        }, 100);
    }

    const goToConcreteEmbodiedEmission = () => {
        setTimeout(() => {
            navigate(`/asphalt-embodied-emission/${id}?backref=pavement-design`);
        }, 100);
    }

    const goToAsphaltEmbodiedEmission = () => {
        setTimeout(() => {
            navigate(`/asphalt-embodied-emission/${id}?backref=pavement-design`);
        }, 100);
    }

    const goToPavementDesign = () => {
        setTimeout(() => {
            navigate(`/pavement-design/${id}?backref=result`);
        }, 100);
    }

    return (
        <>
            <SideNav id={id} active={"pedegree-matrix"} passed={["pavement-context-basic", "pavement-context-custom", "concrete-embodied-emission", "asphalt-embodied-emission"]}
                goToBasicContext={goToBasicContext}
                goToDetailedContext={goToDetailedContext}
                goToAsphaltEmbodiedEmission={goToAsphaltEmbodiedEmission}
                goToConcreteEmbodiedEmission={goToConcreteEmbodiedEmission}
                goToPedegreeMatrix={goToPedegreeMatrix}
                goToPavementDesign={goToPavementDesign}
            />
            <Container>

            <Row>
                <Col>

                    <div className="pcb__sub">
                        <h3 className="pcb__sub-title">Context Parameters</h3>
                        <div className="pcb__box">
                            <table className="pcc__table">
                                <thead>
                                    <tr>
                                        <th className="pcc__table-header" style={{ width: "100px" }}>Indicator</th>
                                        <th className="pcc__table-header">Traffic Inputs</th>
                                        <th className="pcc__table-header" style={{ width: "130px" }}>Indicator Score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Reliability */}
                                    <tr>
                                        <td className="pmatrix__label">Reliability</td>
                                        <td className="pcc__table-element">
                                            <Form.Select
                                                size="sm"
                                                style={{ width: "98%" }}
                                                name="aadtAllLane.distribution"
                                                id="state"
                                            // value={data.aadtAllLane.distribution}
                                            // onChange={handleChange}
                                            >
                                                <option value="1">Verified data by measurements</option>
                                                <option value="2">Verified data partly based on assumptions or non-verified data by measurements</option>
                                                <option selected value="3">Non-verified data partly by assumptions</option>
                                                <option value="4">Qualified estimate (e.g., by industrial expert</option>
                                                <option value="5">Non-qualified estimate</option>
                                            </Form.Select>
                                        </td>
                                        <td className="pcc__table-element">
                                            <Form.Control
                                                type="number"
                                                size="sm"
                                                style={{ width: "95%" }}
                                                name="aadtPerLane.min"
                                                value={5}
                                            // onChange={handleChange} 
                                            />
                                        </td>
                                    </tr>

                                    {/* Completeness */}
                                    <tr>
                                        <td className="pmatrix__label">Completeness</td>
                                        <td className="pcc__table-element">
                                            <Form.Select
                                                size="sm"
                                                style={{ width: "98%" }}
                                                name="aadtAllLane.distribution"
                                                id="state"
                                            // value={data.aadtAllLane.distribution}
                                            // onChange={handleChange}
                                            >
                                                <option value="1">Representative data from sufficient sample of sites over an adequate period to even out normal fluctuations</option>
                                                <option value="1">Representative data from a smaller number of sites but not adequate periods</option>
                                                <option value="1">Representative data from adequate number of sites but from shorter periods</option>
                                                <option value="1">Representative data but from a smaller number of sites and shorter periods or incomplete data from an adequate number of sites and periods.</option>
                                                <option value="1">Representativeness Unknown or incomplete data from a smaller number of sites and/or from shorter periods</option>
                                            </Form.Select>
                                        </td>
                                        <td className="pcc__table-element">
                                            <Form.Control
                                                type="number"
                                                size="sm"
                                                style={{ width: "95%" }}
                                                name="aadtPerLane.min"
                                                value={5}
                                            // onChange={handleChange} 
                                            />
                                        </td>
                                    </tr>


                                    {/* Temporal Correlation */}
                                    <tr>
                                        <td className="pmatrix__label">Temporal Correlation</td>
                                        <td className="pcc__table-element">
                                            <Form.Select
                                                size="sm"
                                                style={{ width: "98%" }}
                                                name="aadtAllLane.distribution"
                                                id="state"
                                            // value={data.aadtAllLane.distribution}
                                            // onChange={handleChange}
                                            >
                                                <option value="1">Age of data unknown or more than 15 years difference</option>
                                                <option value="1">Age of data unknown or more than 15 years difference</option>
                                                <option value="1">Age of data unknown or more than 15 years difference</option>
                                                <option value="1">Age of data unknown or more than 15 years difference</option>
                                                <option value="1">Age of data unknown or more than 15 years difference</option>
                                            </Form.Select>
                                        </td>
                                        <td className="pcc__table-element">
                                            <Form.Control
                                                type="number"
                                                size="sm"
                                                style={{ width: "95%" }}
                                                name="aadtPerLane.min"
                                                value={5}
                                            // onChange={handleChange} 
                                            />
                                        </td>
                                    </tr>



                                    {/* Geographical Correlation */}
                                    <tr>
                                        <td className="pmatrix__label">Geographical Correlation</td>
                                        <td className="pcc__table-element">
                                            <Form.Select
                                                size="sm"
                                                style={{ width: "98%" }}
                                                name="aadtAllLane.distribution"
                                                id="state"
                                                value={5}
                                            // onChange={handleChange}
                                            >
                                                <option value="1">Data from unknown area or are with very different production conditions</option>
                                                <option value="1">Data from unknown area or are with very different production conditions</option>
                                                <option value="1">Data from unknown area or are with very different production conditions</option>
                                                <option value="1">Data from unknown area or are with very different production conditions</option>
                                                <option value="1">Data from unknown area or are with very different production conditions</option>
                                            </Form.Select>
                                        </td>
                                        <td className="pcc__table-element">
                                            <Form.Control
                                                type="number"
                                                size="sm"
                                                style={{ width: "95%" }}
                                                name="aadtPerLane.min"
                                                value={5}
                                            // onChange={handleChange} 
                                            />
                                        </td>
                                    </tr>



                                    {/* Technical Correlation */}
                                    <tr>
                                        <td className="pmatrix__label">Technical Correlation</td>
                                        <td className="pcc__table-element">
                                            <Form.Select
                                                size="sm"
                                                style={{ width: "98%" }}
                                                name="aadtAllLane.distribution"
                                                id="state"
                                            // value={data.aadtAllLane.distribution}
                                            // onChange={handleChange}
                                            >
                                                <option value="1">Data on related processes or material but different technologies</option>
                                            </Form.Select>
                                        </td>
                                        <td className="pcc__table-element">
                                            <Form.Control
                                                type="number"
                                                size="sm"
                                                style={{ width: "95%" }}
                                                name="aadtPerLane.min"
                                                value={5}
                                            // onChange={handleChange} 
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td colSpan={2}>
                                            Aggregated Data Quality Indicator (DQI)
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="number"
                                                size="sm"
                                                style={{ width: "95%" }}
                                                name="aadtPerLane.min"
                                            // value={data.aadtPerLane.min}
                                            // onChange={handleChange} 
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="pcb__box-footer">
                        {/* <Button variant="primary" onClick={goToPedegreeMatrix} >Pedegree Matrix</Button>
                        <Button variant="primary" onClick={goToConcreteEmbodiedEmission}>Concrete Embodied Emission</Button>
                        <Button variant="primary" onClick={goToAsphaltEmbodiedEmission}>Asphalt Embodied Emission</Button>
                        <Button variant="primary" href={`/pavement-context-basic/${id}`}>Basic Input</Button> */}
                        <Button variant="primary" onClick={goToPavementDesign}>Save</Button>
                    </div>

                </Col>
            </Row>
        </Container>
        </>
    );
};

export default PedegreeMatrix;